import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

const LOADERS: { [lang: string]: () => Promise<any> } = {
  en_US: () => import('./en_US'),
  zh_CN: () => import('./zh_CN'),
  zh_TW: () => import('./zh_TW'),
  vi: () => import('./vi'),
  km: () => import('./km'),
  th: () => import('./th'),
  lo: () => import('./lo'),
};

@Injectable()
export class AppTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    const load = LOADERS[lang];
    if (!load) {
      return from(Promise.resolve({}));
    }
    return from(load()).pipe(map((module: any) => module[lang]));
  }
}
